export default "__VITE_ASSET__d3715a3e__"